var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('v-chip',{class:'white--text',attrs:{"color":_vm.status === 'NOT_STARTED'
      ? 'red lighten-2'
      : _vm.status === 'IN_PROGRESS'
      ? 'orange'
      : 'green',"small":""}},[_vm._v(_vm._s(_vm.statusText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }